import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationFrames } from '../../actions/sidebar'
import getFrames from '../../repositories/getFrames'
import NavigationItem from './../../components/NavigationItem'

const mapStateToProps = state => ({
  isToggled: dotProp.get(state, `sidebar.frames.isToggled`, false),
})

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(toggleNavigationFrames(getFrames(window.fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItem)



// WEBPACK FOOTER //
// ./src/containers/NavigationItem/FrameItem.js